import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule,CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA  } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AgGridModule } from 'ag-grid-angular';
import { CalendarModule as fullcalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { CountoModule } from 'angular2-counto';
import { ChartsModule } from 'ng2-charts';
import { ToastrModule } from 'ngx-toastr';
import { FileUploadModule } from 'primeng/fileupload';
import { MultiSelectModule } from 'primeng/multiselect';
import { OrganizationChartModule } from 'primeng/organizationchart';
import { PaginatorModule } from 'primeng/paginator';
import { PickListModule } from 'primeng/picklist';
import { CalendarModule, DataTableModule, RadioButtonModule, TabViewModule } from "primeng/primeng";
import { MasterService } from 'src/app/masters/master.service';
import { UserService } from 'src/app/user/user.services';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { OrganismOrgChartComponent } from './chart/organism-org-chart/organism-org-chart.component';
import { InterceptedHttp } from './common/app.interceptor';
import { LoaderService } from './common/loader.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardService } from './dashboard/dashboard.service';
import { LoginComponent } from './login/login.component';
import { AddAddressComponent } from './masters/add-address/add-address.component';
import { AddContactComponent } from './masters/add-contact/add-contact.component';
import { AddDepartmentComponent } from './masters/add-department/add-department.component';
import { AddHyperSpecialityComponent } from './masters/add-hyper-speciality/add-hyper-speciality.component';
import { AddSpecialityComponent } from './masters/add-speciality/add-speciality.component';
import { AddSubSpecialityComponent } from './masters/add-sub-speciality/add-sub-speciality.component';
import { AreaLevelsComponent } from './masters/area-levels/area-levels.component';
import { GeographyComponent } from './masters/area-levels/geography/geography.component';
import { AddCategoryTypeComponent } from './masters/category-type/add-category-type/add-category-type.component';
import { CategoryTypeComponent } from './masters/category-type/category-type.component';
import { AddCategoryComponent } from './masters/category/add-category/add-category.component';
import { CategoryComponent } from './masters/category/category.component';
import { AddCountryComponent } from './masters/country/add-country/add-country.component';
import { CountryComponent } from './masters/country/country.component';
import { CurrencyComponent } from './masters/currency/currency.component';
import { AddHyperSpecialityMasterComponent } from './masters/hyper-speciality/add-hyper-speciality/add-hyper-speciality.component';
import { HyperSpecialityComponent } from './masters/hyper-speciality/hyper-speciality.component';
import { LegalFormComponent } from './masters/legal-form/legal-form.component';
import { AddProfessionComponent } from './masters/profession/add-profession/add-profession.component';
import { ProfessionComponent } from './masters/profession/profession.component';
import { SpecialitiesComponent } from './masters/specialities/specialities.component';
import { AddSpecialityMasterComponent } from './masters/speciality/add-speciality/add-speciality.component';
import { SpecialityComponent } from './masters/speciality/speciality.component';
import { AddSubSpecialityMasterComponent } from './masters/sub-speciality/add-sub-speciality/add-sub-speciality.component';
import { SubSpecialityComponent } from './masters/sub-speciality/sub-speciality.component';
import { AddMedicalCarePlanComponent } from './medical-file/medical-care-plan/add-medical-care-plan/add-medical-care-plan.component';
import { MedicalCarePlanComponent } from './medical-file/medical-care-plan/medical-care-plan.component';
import { MedicalFileService } from './medical-file/medical-care-plan/medical.file.service';
import { MenuPrivilegesComponent } from './menu-privileges/menu-privileges.component';
import { AddAdministrationComponent } from './partners/administration/add-administration/add-administration.component';
import { AdministrationComponent } from './partners/administration/administration.component';
import { AdministrationService } from './partners/administration/administration.service';
import { AddFinancialComponent } from './partners/financials/add-financial/add-financial.component';
import { FinancialsComponent } from './partners/financials/financials.component';
import { AddHospitalComponent } from './partners/hospitals/add-hospital/add-hospital.component';
import { HospitalsComponent } from './partners/hospitals/hospitals.component';
import { HospitalService } from './partners/hospitals/hospitals.service';
import { AddInsuranceComponent } from './partners/insurance/add-insurance/add-insurance.component';
import { InsuranceComponent } from './partners/insurance/insurance.component';
import { AddLogsticsComponent } from './partners/logistics/add-logistics/add-logistics.component';
import { LogisticsComponent } from './partners/logistics/logistics.component';
import { AddOrganismComponent } from './partners/organisms/add-organism/add-organism.component';
import { OrganismsComponent } from './partners/organisms/organisms.component';
import { OrganismService } from './partners/organisms/organisms.service';
import { PartnerSearchComponent } from './partners/partner-search/partner-search.component';
import { PartnersService } from './partners/partners.service';
import { AddPharmacyComponent } from './partners/pharmacy/add-pharmacy/add-pharmacy.component';
import { PharmacyComponent } from './partners/pharmacy/pharmacy.component';
import { PharmacyService } from './partners/pharmacy/pharmacy.service';
import { AddPractitionerComponent } from './partners/practitioners/add-practitioner/add-practitioner.component';
import { PractitionersComponent } from './partners/practitioners/practitioners.component';
import { PractitionersService } from './partners/practitioners/practitioners.service';
import { AddTelemedicineComponent } from './partners/telemedicines/add-telemedicine/add-telemedicine.component';
import { TelemedicineService } from './partners/telemedicines/telemedicine.service';
import { TelemedicinesComponent } from './partners/telemedicines/telemedicines.component';
import { AddPatientComponent } from './patients/add-patient/add-patient.component';
import { PatientsComponent } from './patients/patients.component';
import { AddSubprofileComponent } from './subprofile/add-subprofile/add-subprofile.component';
import { SubprofileComponent } from './subprofile/subprofile.component';
import { classicTheme } from './theme/classic-theme';
import { optimisticTheme } from './theme/optimistic-theme';
import { royalTheme } from './theme/royal-theme';
import { standardTheme } from './theme/standard-theme';
import { ThemeModule } from './theme/theme-module';
import { AddUserComponent } from './user/add-user/add-user.component';
import { UserComponent } from './user/user.component';
import { FileExportService } from './utils/file-export-service';
import { MedicalFilesComponent } from './medical-files/medical-files.component';
import { AddMedicalFileComponent } from './medical-files/add-medical-file/add-medical-file.component';
import { InitialExaminationComponent } from './medical-files/initial-examination/initial-examination.component';
import { DetailComponent } from './medical-files/detail/detail.component';
import { POMRACTDComponent } from './medical-files/pomr-actd/pomr-actd.component';
import { MedicalCareComponent } from './medical-files/medical-care/medical-care.component';
import { SharedService } from './utils/shared.service';
import { PatientService } from './patients/patient.service';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { FileUploadComponent } from './file-upload/file-upload.component';
import { AskTransferComponent } from './medical-files/ask-transfer/ask-transfer.component';
import { AddTransferDetailComponent } from './medical-files/ask-transfer/add-transfer-detail/add-transfer-detail.component';
import { AppointmentService } from './appointment/appointment.service';
import { EditorModule } from 'primeng/editor';
import { FileUploadService } from './file-upload/file-upload.service';
import { CaseReviewComponent } from './medical-files/case-review/case-review.component';
import { UpDatesComponent } from './medical-files/up-dates/up-dates.component';
import { AddHospitalizationComponent } from './medical-files/up-dates/add-hospitalization/add-hospitalization.component';
import { GridNgSelectDataComponent } from './common/grid-utils/grid-ng-select-component';
import { AddTreatmentComponent } from './medical-files/treatment/add-treatment.component';
import { AddProcedureComponent } from './medical-files/procedure/add-procedure.component';
import { AddProgressComponent } from './medical-files/progress/add-progress.component';
import { AddExamsComponent } from './medical-files/exams/add-exams.component';
import { CustomDateComponent } from './common/grid-utils/custom-date-component.component';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { NgChatModule } from 'ng-chat';
import { WebSocketService } from './utils/chat/websocket.service';
import { AbroadTreatmentComponent } from './medical-files/abroad-treatment/abroad-treatment.component';
import { FollowupComponent } from './medical-files/followup/followup.component';
import { VisitsComponent } from './medical-files/visits/visits.component';
import { UpDatesService } from './medical-files/up-dates/up-dates.service';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { NgxPageScrollModule } from 'ngx-page-scroll';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { AdministrativeFileComponent } from './medical-files/administrative-file/administrative-file.component';
import { IntlTelNumberComponent } from './common/intl-tel-number/intl-tel-number.component';
import { AddHospitalizationService } from './medical-files/up-dates/add-hospitalization/add-hospitalization.service';
import { AddHospitalizationResolver } from './medical-files/up-dates/add-hospitalization/add-hospitalization.resolver';
import { LogisticFileComponent } from './medical-files/logistic-file/logistic-file.component';
import { EncloseFileComponent } from './medical-files/enclose-file/enclose-file.component';
import { DatePipe } from '@angular/common';
import { NumericEditor } from './common/grid-utils/numeric-editor.component';
import { HTTPStatus } from './security/app.HttpListener';
import { AuthService } from './security/auth.service';
import { MedicalFileMastersComponent } from './masters/medical-file-masters/medical-file-masters.component';
import { SortPipe } from './utils/sort.pipe';
import { FilterPipe } from './utils/filter.pipe';
import { GridDateComponent } from './common/grid-utils/grid-date/grid-date.component';
import { RcpComponent } from './rcp/rcp.component';
import { AddRcpComponent } from './rcp/add-rcp/add-rcp.component';
import { MyspaceDashboardComponent } from './myspace-dashboard/myspace-dashboard.component';
import { MyspaceHospitalComponent } from './myspace-hospital/myspace-hospital.component';
import { MyspacePractitionarComponent } from './myspace-practitionar/myspace-practitionar.component';
import { DynamicFormBuilderModule } from './dynamic-form-builder/dynamic-form-builder.module';
import { DynamicFormService } from './dynamic-form-builder/dynamic-form-service';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ChangePasswordService } from './change-password/change-password.service';
import { FormatnumeralPipe } from './utils/formatnumeral.pipe';
import { CustomDatePipe } from './utils/custom.datepipe';


@NgModule({  
  declarations: [
    AppComponent,
    ChangePasswordComponent,
    LoginComponent,
    DashboardComponent,
    OrganismsComponent,
    AddOrganismComponent,
    AddDepartmentComponent,
    AddAddressComponent,
    AddContactComponent,
    UserComponent,
    CurrencyComponent,
    CountryComponent,
    LegalFormComponent,
    AddUserComponent,
    AddCountryComponent,
    SubprofileComponent,
    AddSubprofileComponent,
    HospitalsComponent,
    AddHospitalComponent,
    AddSpecialityComponent,
    PractitionersComponent,
    AddPractitionerComponent,
    FinancialsComponent,
    AddFinancialComponent,
    TelemedicinesComponent,
    AddTelemedicineComponent,
    LogisticsComponent,
    AddLogsticsComponent,
    PharmacyComponent,
    AddPharmacyComponent,
    InsuranceComponent,
    AddInsuranceComponent,
    AddSubSpecialityComponent,
    AddHyperSpecialityComponent,
    AdministrationComponent,
    AddAdministrationComponent,
    SpecialitiesComponent,
    PartnerSearchComponent,
    CategoryComponent,
    CategoryTypeComponent,
    AddCategoryTypeComponent,
    AreaLevelsComponent,
    GeographyComponent,
    ProfessionComponent,
    AddProfessionComponent,
    AddCategoryComponent,
    SpecialityComponent,
    AddSpecialityMasterComponent,
    SubSpecialityComponent,
    AddSubSpecialityMasterComponent,
    HyperSpecialityComponent,
    AddHyperSpecialityMasterComponent,
    MenuPrivilegesComponent,
    PatientsComponent,
    AddPatientComponent,
    MedicalCarePlanComponent,
    AppointmentComponent,
    // ChatComponent,
    MedicalFilesComponent,
    AddMedicalFileComponent,
    InitialExaminationComponent,
    DetailComponent,
    POMRACTDComponent,
    MedicalCareComponent,

    //ChatComponent,
    OrganismOrgChartComponent,
    AddMedicalCarePlanComponent,
    //ChatComponent,
    FileUploadComponent,
    AskTransferComponent,
    AddTransferDetailComponent,
    CaseReviewComponent,
    UpDatesComponent,
    AddHospitalizationComponent,
    GridNgSelectDataComponent,
    NumericEditor,
    AddTreatmentComponent,
    AddProcedureComponent,
    AddProgressComponent,
    AddExamsComponent,
    CustomDateComponent,
    GridDateComponent,
    AbroadTreatmentComponent,
    FollowupComponent,
    VisitsComponent,
    AdministrativeFileComponent,
    IntlTelNumberComponent,
    LogisticFileComponent,
    EncloseFileComponent,
    MedicalFileMastersComponent,
    SortPipe,
    FilterPipe,
    FormatnumeralPipe,
    RcpComponent,
    AddRcpComponent,
    MyspaceHospitalComponent,
    MyspacePractitionarComponent,
    MyspaceDashboardComponent,
    ChangePasswordComponent

  ],
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbModule,
    FormsModule, ReactiveFormsModule,
    MultiSelectModule,
    OrganizationChartModule,
    DataTableModule,
    CalendarModule,
    RadioButtonModule,
    TabViewModule,
    FileUploadModule,
    NgChatModule,
    BsDropdownModule.forRoot(),
    NgxIntlTelInputModule,
    AgGridModule.withComponents([GridNgSelectDataComponent, CustomDateComponent,GridDateComponent,NumericEditor]),
    ThemeModule.forRoot({
      themes: [standardTheme, classicTheme, optimisticTheme, royalTheme],
      active: 'standard'
    })
    ,
    ChartsModule,
    CountoModule,
    PaginatorModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    NgSelectModule,
    PickListModule,
    FileUploadModule,
    fullcalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    NgMultiSelectDropDownModule.forRoot(),
    EditorModule,
    ModalModule.forRoot(),
    NgxPageScrollCoreModule.forRoot({duration: 500}),
    NgxPageScrollModule,
    DynamicFormBuilderModule
  ],
  providers: [
    OrganismService,
    MasterService,
    DynamicFormService,
		HospitalService,
		UserService,
    SharedService,
		DashboardService,
		PractitionersService,
		TelemedicineService,
		PharmacyService,
		PartnersService,
		AdministrationService,
		LoaderService,
		FileExportService,
		PatientService,
    MedicalFileService,
		AppointmentService,
    FileUploadService,
    HTTPStatus,
    BsModalService,
    AuthService,
    { provide: HTTP_INTERCEPTORS, useClass: InterceptedHttp, multi: true },
    WebSocketService,
    UpDatesService,
    AddHospitalizationService,
    ChangePasswordService,
    AddHospitalizationResolver,DatePipe,FormatnumeralPipe,CustomDatePipe
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
